import { IcoShield16 } from '@onefootprint/icons';
import type { ApiNodeDataAiDecision } from '@onefootprint/request-types/dashboard';
import { AGENT_ICON_COMPONENTS, DEFAULT_AGENT_ICON } from '@/components/agent-icon-picker/agent-icons';
import type { NodeIconProps } from '../../components/node-icon';

export const getAiDecisionIcon = (data: ApiNodeDataAiDecision): NodeIconProps => {
  if (data.config?.kind === 'agent') {
    const Icon = AGENT_ICON_COMPONENTS[DEFAULT_AGENT_ICON];
    return { Icon, color: 'info' };
  }
  return { Icon: IcoShield16, color: 'primary' };
};
